export default __webpack_public_path__ + "static/abb02a8d10bb95a2e50e2a06a64b5799.png";